module.exports = __webpack_public_path__ + "static/media/creativ11.af9857f1.jpg";